<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2022-06-22 18:20:16
-->
<template>
 <div div style="background:#fff">
    <div class="yygh-title">预约挂号</div>
    <Common>
      <template slot="cd">
        <CdhospitalBookTab currentIndex="1"/>
        <CdhospitalAPPBook />
      </template>
      <template slot="sz">
        <SzhospitalBookTab currentIndex="1"/>
        <SzhospitalAPPBook />
      </template>
      <template slot="hf">
             <HfhospitalBookTab currentIndex="1"/>
              <HfhospitalAPPBook />
       
       
      </template>
    </Common>
    </div>
</template>

<script>
import CdhospitalAPPBook from "@/components/hospitalAPPBook/cdhospitalAPPBook"
import SzhospitalAPPBook from "@/components/hospitalAPPBook/szhospitalAPPBook"
import CdhospitalBookTab from "@/components/hospitalBookTab/cdhospitalBookTab"
import SzhospitalBookTab from "@/components/hospitalBookTab/szhospitalBookTab"
import HfhospitalAPPBook from "@/components/hospitalAPPBook/hfhospitalAPPBook"
import HfhospitalBookTab from "@/components/hospitalBookTab/hfhospitalBookTab"
export default{
  components:{
    CdhospitalAPPBook,
    SzhospitalAPPBook,
    HfhospitalAPPBook,
    SzhospitalBookTab,
    CdhospitalBookTab,
    HfhospitalBookTab
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>
.yygh-title{
  text-align: center;
  font-size: 30px;
  line-height: 30px;
  padding-top:50px;
  background: #fff;
}
.m-screen-mobile .yygh-title {
  padding-top: 0.8rem;
  font-size: 0.45rem!important;
  text-align: center;
  line-height: 0.46rem!important;
}
</style>